export const FEATURE_SETS = [
  { id: "assurance", label: "Assurance" },
  { id: "lab_testing", label: "Lab and testing" },
  { id: "device_management", label: "Network device management" },
  { id: "lifecycle", label: "Lifecycle" },
] as const;

export type FeatureSet = typeof FEATURE_SETS[number]["id"];

export function routeFeatures(path: string): FeatureSet[] {
  const root = path.split("/")[1];
  switch (root) {
    case "alerts": case "events": case "investigate": case "diagnostics": case "scorecard": case "map":
      return ["assurance"];
    case "lab-scenarios": case "campaigns": case "campaign-runs": case "sessions":
    case "session-pairs": case "traffic-profiles": case "lab": case "security":
    case "network": case "vrfs": case "changes": case "config":
      return ["lab_testing"];
    case "access":
      return ["lab_testing", "device_management"];
    case "refreshes":
      return ["lifecycle"];
    case "devices":
      if (/^\/devices\/refreshes(?:\/|$)/.test(path)) return ["lifecycle"];
      return ["device_management", "lifecycle"];
    case "tests":
      return ["assurance", "lab_testing"];
    case "admin":
      return /^\/admin\/(notifications|maintenance)(\/|$)/.test(path) ? ["assurance"] : [];
    default:
      return /^\/agents\/[^/]+\/config$/.test(path) ? ["lab_testing"] : [];
  }
}
